import { createContext } from 'react';

const deleteConfirmDialogContext = createContext();

export default deleteConfirmDialogContext;